export default "__VITE_ASSET__CUEjRzgy__"